const en = {
  kicker: "For local businesses & homeowners",
  title: "Become a host on Trollfossjakten.",
  lead: "A host is a local business or homeowner along the trail between Lavangen and Årstein (Gratangen) — a café, farm, cabin, B&B, sauna or shop. Hosts welcome troll-hunt guests and accept Troll Kroner (TK), the game's own money, as payment.",
  badges: ["Free", "About 2 minutes", "Live on the map right away"],
  waysKicker: "Two ways to take part",
  waysTitle: "Pick one — or do both.",
  ways: [
    { title: "Host place", tag: "Accepts Troll Kroner", body: "You show up on the map, and guests can pay you with the TK in their wallet." },
    { title: "Pit stop", tag: "Listing only", body: "A map pin showing your services, such as car or bike charging, showers, food menu, B&B, camping, wifi, parking, toilet and coffee. Free visibility — no money is handled." },
  ],
  both: "You can do both.",
  joinKicker: "How to become a host",
  joinTitle: "About 2 minutes, and free.",
  steps: ["Download the app and sign in.", "Go to Profile → Become a host → Register as a host.", "Fill in your details (see the list).", "That's it — you're live on the map right away."],
  formTitle: "What you fill in",
  fields: [["Business name", "required"], ["Address", "required"], ["Phone", "optional"], ["What you offer", "e.g. “coffee, waffles, sauna”"]],
  amenitiesTitle: "Your amenities",
  noWait: "No approval wait and no sign-up fee.",
  pitTitle: "Adding a pit stop",
  pitBody: "Go to Profile → Host a pit stop → Register a pit stop, then enter name, address, phone, map position and amenities.",
  tkKicker: "How Troll Kroner work",
  tkTitle: "1 TK = 1 NOK.",
  tkEarnTitle: "Guests earn TK by",
  tkEarn: ["Inviting friends — they get 50% back of a friend's first pass purchase", "Arrow Hunter rank bonuses: +10 / +25 / +100 TK", "Spinning the prize wheel"],
  tkRule: "TK can only be spent at registered hosts. Guests can't cash them out.",
  payKicker: "Taking a payment",
  payTitle: "Your host dashboard does the maths.",
  paySteps: ["The guest opens Profile → Show my payment QR.", "You scan it or type in their wallet code (TK-XXXXXX).", "Enter the amount in NOK and what they bought, e.g. “coffee & waffles”.", "The app takes as much as possible from their TK balance and shows the rest to collect in cash or card."],
  exampleTitle: "Example",
  example: { note: "85 kr purchase, 60 TK in the wallet", total: "Purchase", tk: "Paid with TK", rest: "To collect in cash or card" },
  dashboard: "Your dashboard shows every sale, plus today's and total TK received.",
  ctaTitle: "Ready to welcome troll guests?",
  ctaBody: "Get the app, sign in and register as a host — it takes about two minutes.",
  cta: "Get the app",
  ctaPartner: "Want your own trolls too? See partner packages",
  ctaHost: "Register as a host",
  webNote: "Prefer the web? Register here — mark your place on the map, tell us what you offer and tick your amenities.",
};

export default en;
